module.exports = __webpack_public_path__ + "static/media/ku.cc35a46b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/ku.png
// module id = 813
// module chunks = 0